import React from "react";
import { Reveal, Overline, Stagger, StaggerItem } from "./Reveal";
import { WOOD_STEPS, WOOD_FLOW, IMAGES } from "../lib/content";

export const WoodMartSection = () => (
  <section data-testid="woodmart-section" className="bg-midnight text-ivory py-24 lg:py-32 noise-overlay">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal className="max-w-3xl">
        <Overline>Wood Mart — Business Model</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight">
          A Smarter Approach to Furniture
        </h2>
        <p className="mt-6 text-lg text-ivory/60 leading-relaxed">
          A hybrid model that connects branded furniture, curated local vendors, and controlled customization — with KRVMart quality and installation at the end of every order.
        </p>
      </Reveal>

      <Stagger className="mt-16 grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {WOOD_STEPS.map((s, i) => (
          <StaggerItem key={s.title} className="border border-white/10 p-6 bg-navy/40 hover:border-gold/40 transition-colors">
            <span className="font-serif text-3xl text-gold">0{i + 1}</span>
            <h4 className="mt-4 font-medium text-lg text-ivory">{s.title}</h4>
            <p className="mt-2 text-sm text-ivory/55 leading-relaxed">{s.desc}</p>
          </StaggerItem>
        ))}
      </Stagger>

      {/* Process flow */}
      <Reveal className="mt-16 border border-white/10 p-8 lg:p-10 bg-navy/30">
        <p className="text-xs uppercase tracking-[0.25em] text-gold mb-6">Fulfilment Flow</p>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-4">
          {WOOD_FLOW.map((step, i) => (
            <React.Fragment key={step}>
              <span className="text-sm sm:text-base text-ivory/80">{step}</span>
              {i < WOOD_FLOW.length - 1 && <span className="text-gold">→</span>}
            </React.Fragment>
          ))}
        </div>
      </Reveal>

      {/* Signature Collection */}
      <div className="mt-28 grid lg:grid-cols-12 gap-12 items-center">
        <Reveal delay={0.1} className="lg:col-span-6">
          <div className="overflow-hidden">
            <img src={IMAGES.signature} alt="Wood Mart Signature Collection concept" className="w-full h-[420px] lg:h-[520px] object-cover" />
          </div>
        </Reveal>
        <Reveal className="lg:col-span-6">
          <Overline>Future — Signature Collection</Overline>
          <h3 className="font-serif font-light text-3xl sm:text-5xl tracking-tight">
            Wood Mart Signature Collection
          </h3>
          <p className="mt-3 text-gold text-sm uppercase tracking-[0.15em]">Designed for Modern Urban Living.</p>
          <p className="mt-6 text-ivory/60 leading-relaxed max-w-xl">
            The Signature Collection will represent a curated range of furniture developed specifically for Wood Mart — combining standardized specifications, selected materials, controlled quality, and distinctive designs.
          </p>
          <p className="mt-4 text-ivory/50 leading-relaxed max-w-xl">
            Our long-term vision is to develop exclusive furniture designs that can eventually be scaled across KRVMart locations.
          </p>
          <span className="mt-6 inline-block text-xs uppercase tracking-[0.2em] text-gold/70 border border-gold/30 px-4 py-2">
            Planned & Developing
          </span>
        </Reveal>
      </div>
    </div>
  </section>
);
